import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustSignalsSection = () => {
  const partnerships = [
  {
    id: 1,
    name: "Ministère de l\'Éducation Nationale",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1a77f076a-1767585645732.png",
    logoAlt: "Logo officiel du Ministère de l\'Éducation Nationale du Sénégal avec emblème national et texte en français"
  },
  {
    id: 2,
    name: "Université Cheikh Anta Diop",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_116cb8e27-1769645774646.png",
    logoAlt: "Logo de l\'Université Cheikh Anta Diop de Dakar montrant architecture académique moderne avec colonnes"
  },
  {
    id: 3,
    name: "Institut Supérieur de Management",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1bafdc96f-1769645776948.png",
    logoAlt: "Logo de l\'Institut Supérieur de Management avec symboles d\'excellence académique et business"
  },
  {
    id: 4,
    name: "École Polytechnique de Thiès",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1dd9a03ee-1769645773800.png",
    logoAlt: "Logo de l\'École Polytechnique de Thiès avec symboles d\'ingénierie et technologie moderne"
  }];


  const testimonials = [
  {
    id: 1,
    name: "Amadou Diallo",
    role: "Étudiant en Informatique",
    school: "Université Cheikh Anta Diop",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1e1e19e2c-1763293317183.png",
    avatarAlt: "Portrait professionnel d'Amadou Diallo, jeune homme sénégalais souriant avec chemise bleue et lunettes",
    content: "Grâce à CURSUS Orientation, j'ai découvert ma passion pour l'informatique. L'IA m'a aidé à comprendre mes forces et à choisir la filière parfaite pour moi.",
    rating: 5
  },
  {
    id: 2,
    name: "Fatou Sall",
    role: "Étudiante en Médecine",
    school: "Faculté de Médecine de Dakar",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_123dec6e5-1763293315867.png",
    avatarAlt: "Portrait professionnel de Fatou Sall, jeune femme sénégalaise confiante avec hijab bleu et sourire chaleureux",
    content: "Les quiz m'ont permis de confirmer mon choix pour la médecine. Le système de gamification rend l'orientation amusante et motivante.",
    rating: 5
  },
  {
    id: 3,
    name: "Moussa Ndiaye",
    role: "Étudiant en Commerce",
    school: "Institut Supérieur de Management",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_146db267c-1763296357676.png",
    avatarAlt: "Portrait professionnel de Moussa Ndiaye, jeune homme sénégalais en costume noir avec cravate et expression déterminée",
    content: "J'étais perdu avant d'utiliser cette plateforme. Maintenant, je suis en commerce international et je sais exactement où je vais dans ma carrière.",
    rating: 5
  }];


  return (
    <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full mb-4 shadow-sm">
            <Icon name="Shield" size={20} color="var(--color-primary)" />
            <span className="text-sm md:text-base font-medium text-blue-700">
              Confiance et Crédibilité
            </span>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Reconnu par les Leaders de l'Éducation
          </h2>

          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto">
            CURSUS Orientation est approuvé par le Ministère de l'Éducation et partenaire de plus de 200 établissements au Sénégal.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 lg:p-12 shadow-xl mb-12 md:mb-16">
          <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-6 md:mb-8 text-center">
            Nos Partenaires Institutionnels
          </h3>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {partnerships?.map((partner) =>
            <div
              key={partner?.id}
              className="flex flex-col items-center justify-center p-4 md:p-6 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors duration-300">

                <div className="w-full h-16 md:h-20 mb-3 md:mb-4 flex items-center justify-center">
                  <Image
                  src={partner?.logo}
                  alt={partner?.logoAlt}
                  className="max-w-full max-h-full object-contain" />

                </div>
                <p className="text-xs md:text-sm text-gray-700 text-center font-medium line-clamp-2">
                  {partner?.name}
                </p>
              </div>
            )}
          </div>
        </div>

        <div>
          <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-6 md:mb-8 text-center">
            Ce que disent nos étudiants
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {testimonials?.map((testimonial) =>
            <div
              key={testimonial?.id}
              className="bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">

                <div className="flex items-center gap-1 mb-4">
                  {[...Array(testimonial?.rating)]?.map((_, index) =>
                <Icon
                  key={index}
                  name="Star"
                  size={20}
                  color="#F59E0B"
                  className="fill-amber-500" />

                )}
                </div>

                <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                  "{testimonial?.content}"
                </p>

                <div className="flex items-center gap-3 md:gap-4">
                  <Image
                  src={testimonial?.avatar}
                  alt={testimonial?.avatarAlt}
                  className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover" />

                  <div className="flex-1 min-w-0">
                    <div className="text-sm md:text-base font-bold text-gray-900">
                      {testimonial?.name}
                    </div>
                    <div className="text-xs md:text-sm text-gray-600">
                      {testimonial?.role}
                    </div>
                    <div className="text-xs text-gray-500 line-clamp-1">
                      {testimonial?.school}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default TrustSignalsSection;